import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorNotificationService {

  private notificationSubject = new BehaviorSubject<string>('');
  public errorNotification$ = this.notificationSubject.asObservable();

  constructor() { }

  notify(message: string) {
    this.notificationSubject.next(message);
  }

  getErrorMessage() : string {
    return this.notificationSubject.value;
  }
}
